var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0834 21.0833L19.1667 19.1667M11.0209 20.125C12.2165 20.125 13.4004 19.8895 14.5049 19.432C15.6095 18.9744 16.6131 18.3038 17.4585 17.4584C18.3039 16.613 18.9745 15.6094 19.4321 14.5048C19.8896 13.4003 20.1251 12.2164 20.1251 11.0208C20.1251 9.82525 19.8896 8.64138 19.4321 7.53681C18.9745 6.43224 18.3039 5.42861 17.4585 4.58321C16.6131 3.73781 15.6095 3.0672 14.5049 2.60967C13.4004 2.15214 12.2165 1.91666 11.0209 1.91666C8.60634 1.91666 6.29066 2.87584 4.5833 4.58321C2.87593 6.29057 1.91675 8.60625 1.91675 11.0208C1.91675 13.4354 2.87593 15.7511 4.5833 17.4584C6.29066 19.1658 8.60634 20.125 11.0209 20.125V20.125Z",
    stroke: "#ACA59D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDashboard);
export default __webpack_public_path__ + "static/media/search-dashboard.01bdcc1090a3935d7863fa4cc90d41d1.svg";
export { ForwardRef as ReactComponent };